export default "__VITE_ASSET__COkIfpoj__"